export function roleLabel(role: string | undefined): string {
  switch (role) {
    case 'KALOTTE':
      return 'Admin';
    case 'RUBY':
      return 'Ruby';
    case 'KALOTTE_VIEWER':
      return 'Lesen';
    case 'KALOTTE_OPERATOR':
      return 'Produktion';
    default:
      return role || '';
  }
}
